import { render } from "./ProspectTags.vue?vue&type=template&id=4caedf20"
import script from "./ProspectTags.vue?vue&type=script&lang=js"
export * from "./ProspectTags.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__